var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardReject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.831571 0C0.671866 0 0.50486 0.0537151 0.382975 0.175503C0.139269 0.419702 0.139269 0.829401 0.382975 1.0736L4.30307 4.99641L0.382975 8.91922C0.139269 9.16342 0.139269 9.57312 0.382975 9.81732C0.626745 10.0609 1.0364 10.0609 1.28017 9.81732L5.2002 5.89452L9.12022 9.81732C9.36399 10.0609 9.77365 10.0609 10.0174 9.81732C10.2611 9.57312 10.2611 9.16342 10.0174 8.91922L6.09732 4.99641L10.0174 1.0736C10.2611 0.829401 10.2611 0.419702 10.0174 0.175503C9.89553 0.0537151 9.72846 0 9.56882 0C9.40912 0 9.24217 0.0537151 9.12022 0.175503L5.2002 4.0983L1.28017 0.175503C1.15828 0.0537151 0.991275 0 0.831571 0Z",
    fill: "#FF4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardReject);
export default __webpack_public_path__ + "static/media/reward-reject.4c8b73a4f22e1be1d0152aad1518ac59.svg";
export { ForwardRef as ReactComponent };